import React, { useEffect } from "react";
import DMSHeader from "../../DMSHeader/DMSHeader";
//import DailyFloodReportCompTable from "./DailyFloodReportCompTable";
import { useTranslation } from "react-i18next";
import DailyGlofReportForm from "./DailyGlofReportForm";
import "../ReportEnhanced.css";

const DailyGlofReport = () => {
  const { t } = useTranslation();

  return (
    <div className="report-enhanced-wrapper">
      <div className="report-header-enhanced">
        <DMSHeader title="GLOF Daily Report" />
      </div>
      <div className="report-table-enhanced">
        <DailyGlofReportForm />
      </div>
    </div>
  );
};

export default DailyGlofReport;
